import type { FC } from 'react';

import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import { PartRegion } from '@/features/storefront/parts/PartRegion';
import type { ProductViewProps } from '@/features/storefront/layouts/product/types';

/**
 * A marketplace product page: the picture with its views stood up in a rail
 * beside it, and a buy column that stays put while the page runs on.
 *
 * Tighter than Serra's on both axes - a narrower gutter, less top padding, a
 * square picture rather than a portrait one. The same components, arranged the
 * way a shopper who arrived to compare specifications wants them: the price and
 * the button reachable without scrolling, and the facts directly under them.
 */
export const Product: FC<ProductViewProps> = () => (
  <StorefrontContainer className="grid gap-10 py-8 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)]">
    <PartRegion name="gallery" />
    <PartRegion name="main" className="min-w-0 lg:sticky lg:top-24 lg:self-start" />
  </StorefrontContainer>
);
